import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useUser } from '../context/UserContext';
import 'antd/dist/reset.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useUser();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data } = await api.post('/Usuario/login', {
        Usuario: values.username,
        Contrasena: values.password,
      });
      login(data); // data contiene usuarioId, nombreUsuario, rolId, rolNombre, esAdmin, permisos
      message.success(data.mensaje || 'Autenticación exitosa');
      navigate('/dashboard');
    } catch (error) {
      const apiError = error.response?.data;
      if (apiError?.errors) {
        const msgs = Object.entries(apiError.errors)
          .flatMap(([, arr]) => arr)
          .join(' ');
        message.error(msgs);
      } else {
        message.error(apiError?.mensaje || 'Error al iniciar sesión');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Card title="Iniciar Sesión" style={{ width: 360, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
        <Form name="login" onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Usuario"
            name="username"
            rules={[{ required: true, message: 'Por favor ingresa tu usuario' }]}
          >
            <Input placeholder="Usuario" />
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
          >
            <Input.Password placeholder="Contraseña" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Ingresar
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
